import { forwardRef } from 'react';
import { getFieldInputStyles } from '../FieldStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const FieldInput = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    hasFocusedValue = false,
    name,
    isInvalid = false,
    showLabel = true,
    disabled = false,
    readOnly = false,
    ...rest
  } = props;
  return jsx("input", {
    name: name,
    id: name,
    ref: ref,
    readOnly: readOnly,
    disabled: disabled,
    css: getFieldInputStyles(isInvalid, showLabel, disabled, readOnly, hasFocusedValue),
    ...rest
  });
});
FieldInput.displayName = 'FieldInput';

export { FieldInput };
//# sourceMappingURL=FieldInput.js.map
